var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaticLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:none;}.cls-4{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 250,
    cy: 250,
    r: 244.91
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -116.09,
    y1: 25.97,
    x2: 437.45,
    y2: 364.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a229c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b3fe4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -18.1,
    y: -18.1,
    width: 536.2,
    height: 536.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m320.83,302.85l69.29-40.01c3.67-2.12,5.94-6.06,5.94-10.3v-80.01c0-4.23-2.28-8.18-5.94-10.3l-69.29-40.01c-3.67-2.12-8.22-2.11-11.89,0l-69.29,40.01c-3.67,2.12-5.94,6.07-5.94,10.3v142.99l-48.59,28.05-48.59-28.05v-56.11l48.59-28.05,32.05,18.5v-37.64l-26.11-15.07c-1.8-1.04-3.86-1.59-5.95-1.59s-4.15.55-5.94,1.59l-69.29,40.01c-3.67,2.12-5.94,6.06-5.94,10.3v80.01c0,4.23,2.28,8.18,5.94,10.3l69.29,40.01c3.66,2.11,8.22,2.11,11.89,0l69.29-40c3.67-2.12,5.94-6.07,5.94-10.3v-142.99l.88-.5,47.71-27.55,48.59,28.05v56.11l-48.59,28.05-32-18.48v37.64l26.06,15.05c3.67,2.11,8.22,2.11,11.89,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaticLogo);
export default __webpack_public_path__ + "static/media/MATICLogo.cd4fae9a0cfd9e4b4897fffb45845170.svg";
export { ForwardRef as ReactComponent };